/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime: 2020-08-07 19:12:38
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\beforeonload\beforeonload.js
 * @Description: 
 */
'use strict';

/**
 * 页面关闭事件
 */
angular.module('beforeonloadModule', [])
    . factory('beforeonload', ['$timeout', function($timeout) {
        var scopeObj = {};
        return {

            /**
         * [listener description] 建立关闭监听
         * @param  {Function} callback [description]
         * @return {[type]}            [description]
         */
            listener: function(flag, scope_) {
                window.removeEventListener('beforeunload', scope_.listener);
                if (flag) {
                    window.addEventListener('beforeunload', scope_.listener);
                }
            },

            /**
         * [watcher description] 检查器
         * @param {object} [$scope] [description]
         * @return {[type]} [description]
         */
            doWatcher: function(scope_) {
                var $scope = scope_.$scope;
                var self = this;
                return $scope.$watch('list', function(newV, oldV) {
                    var theList = JSON.stringify(angular.copy(newV));
                    self.listener($scope.orgList != theList, scope_);
                }, true);
            },

            /**
            * [copy description] 拷贝数据
            * @return {[type]}      [description]
            */
            refresh: function($scope) {
                var scope_ = scopeObj[$scope.$id];
                if (!scope_) {return;}
                var self = this;
                this.destroy(scope_);
                $timeout(function() {
                    self.copy(scope_.$scope);
                    scope_.watcher = self.doWatcher(scope_);
                }, 400);
            },

            /**
         * [copy description] 复制数据
         * @param  {[type]} $scope [description]
         * @return {[type]}        [description]
         */
            copy: function($scope) {
                $scope.list.randomKey = 'listId:' + Math.round(Math.random() * 10000); // 为了触发保存时的数据更新
                $scope.orgList = JSON.stringify(angular.copy($scope.list));
            },

            /**
         * [beforeonloadAlert description] 初始化架设监控
         * @param  {[type]} $scope [description] 被监控的节点
         * @return {[type]}        [description]
         */
            beforeonloadAlert: function($scope) {
                scopeObj[$scope.$id] = { $scope: $scope };
                scopeObj[$scope.$id].listener = function(event) {
                    event.returnValue = '我在这写点东西...';
                };
                var self = this;
                self.copy(scopeObj[$scope.$id].$scope);
                scopeObj[$scope.$id].watcher = self.doWatcher(scopeObj[$scope.$id]);
                scopeObj[$scope.$id].$scope.$on('$destroy', function() {
                    if (typeof watcher === 'function') {
                        scopeObj[$scope.$id].watcher();
                    }
                    window.removeEventListener('beforeunload', scopeObj[$scope.$id].listener);
                });
            },

            /**
         * [destroy description] 销毁监控
         * @return {[type]} [description]
         */
            destroy: function(scope_) {
                if (!scope_) {return;}
                window.removeEventListener('beforeunload', scope_.listener);
                if (typeof scope_.watcher !== 'function') {return;}
                scope_.watcher();
            }
        };
    }]);
